export default {
  GET_CALENDAR (state, data) {
    state.calendar_inventory = data.inventory
    state.calendar_camping = data.camping
    state.calendar_accomodation = data.accomodation
    state.calendar_external_accomodation = data.external_accomodation
  },
  GET_ALL_RECORDS (state, data) {
    state.conservation_fees_calendar = data.conservancy_fees
    state.vehicle_fees_calendar = data.vehicles
  },
  GET_CONSERVATION_BOOKINGS (state, data) {
    state.conservation_bookings = data.data
  },
  GET_VEHICLE_BOOKINGS (state, data) {
    state.vehicle_bookings = data.data
  }
}
